export const LEVEL_STYLES = {
	l1: {
		pill: { background: "#6de0e0", color: "#032e2e" },
		line: "#6de0e0",
		card: { background: "#e0f9f9", border: "1.5px solid #6de0e0" },
		name: "#065252",
		metric: "#a8eeee",
		label: "#0e8a8a",
		value: "#032e2e",
		dash: "#22baba",
	},
	l2: {
		pill: { background: "#85B7EB", color: "#042C53" },
		line: "#85B7EB",
		card: { background: "#E6F1FB", border: "1.5px solid #85B7EB" },
		name: "#0C447C",
		metric: "#B5D4F4",
		label: "#185FA5",
		value: "#042C53",
		dash: "#378ADD",
	},
	l3: {
		pill: { background: "#AFA9EC", color: "#26215C" },
		line: "#AFA9EC",
		card: { background: "#EEEDFE", border: "1.5px solid #AFA9EC" },
		name: "#3C3489",
		metric: "#CECBF6",
		label: "#534AB7",
		value: "#26215C",
		dash: "#7F77DD",
	},
};
